import { render, staticRenderFns } from "./DevelopmentModal.vue?vue&type=template&id=2d09099f&scoped=true"
import script from "./DevelopmentModal.vue?vue&type=script&lang=ts"
export * from "./DevelopmentModal.vue?vue&type=script&lang=ts"
import style0 from "./DevelopmentModal.vue?vue&type=style&index=0&id=2d09099f&prod&lang=scss"
import style1 from "./DevelopmentModal.vue?vue&type=style&index=1&id=2d09099f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d09099f",
  null
  
)

export default component.exports